import axios from 'axios'
import config from './config'
// import aes from './aes.js'
import aes from './crypto.js'
import { useMainStore } from '@/store'

axios.defaults.baseURL = config.baseURL

const TOKEN_KEY = 'yjwltoken'
// 这些页面本身负责处理登录态：校验失败要保持在当前页展示原因，不能再被全局拦截器跳走
const AUTH_PAGES = ['/login', '/singleLogin', '/logout', '/logoutUser', '/AppLogin', '/Unauthorized']

function gettoken() {
	return localStorage.getItem(TOKEN_KEY) || ''
}

// 创建一个axios实例
const instance = axios.create({
	timeout: 300000,
	headers: {
		'Content-Type': 'application/json'
	}
})

const initialToken = gettoken()
if (initialToken) instance.defaults.headers.Authorization = 'Bearer ' + initialToken

instance.fileUrl = config.fileurl
instance.token = initialToken

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = (token) => {
	token = token || ''
	instance.token = token
	if (token) {
		instance.defaults.headers.Authorization = 'Bearer ' + token
		localStorage.setItem(TOKEN_KEY, token)
	} else {
		delete instance.defaults.headers.Authorization
		localStorage.removeItem(TOKEN_KEY)
	}
}

function isAuthPage() {
	const path = (window.location.pathname || '/').replace(/\/+$/, '') || '/'
	return AUTH_PAGES.indexOf(path) > -1
}

function clearLocalAuth() {
	localStorage.removeItem(TOKEN_KEY)
	localStorage.removeItem('store')
	localStorage.removeItem('openCoursePage')
	instance.token = ''
	delete instance.defaults.headers.Authorization
	try {
		const mainStore = useMainStore()
		mainStore.setToken('')
		mainStore.setUserInfo(null)
		mainStore.setSSOUser({})
		mainStore.setSysInfo({})
	} catch (e) {
		// pinia 未初始化时只清浏览器存储
	}
}

// 登录态失效只允许跳一次：并发请求同时返回 3002/4002 时不能反复弹窗、reload，
// 否则带 ticket 的地址会在“校验失败 → reload → 再校验”之间死循环。
let authRedirecting = false

function goSsoLogin(reason) {
	if (authRedirecting) return
	authRedirecting = true
	clearLocalAuth()
	const query = 'service=' + encodeURIComponent(config.locationOrigin) +
		'&force=1&reason=' + encodeURIComponent(reason || 'expired')
	window.location.replace(config.ssoServers + '/singleLogin?' + query)
}

function refreshToken() {
	const mainStore = useMainStore()
	const userId = mainStore.userInfo && mainStore.userInfo.id
	// RefreshToken 自身的失败交给下面统一定向，不能再触发一次刷新
	return instance.get('api/User/RefreshToken/' + userId, { skipAuthHandler: true }).then(res => res.data)
}

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，等待刷新结果后再重放
let requests = []

function flushRequests(error, token) {
	const queue = requests
	requests = []
	queue.forEach(item => {
		if (error || !token) {
			item.reject(error || new Error('登录状态已失效'))
			return
		}
		item.config.headers.Authorization = 'Bearer ' + token
		item.resolve(instance(item.config))
	})
}

// 实例默认头是 application/json，axios 1.x 的 transformRequest 遇到它会把 FormData 转成 JSON 字符串（文件字段被丢掉），
// 带文件的上传接口因此收到非 multipart 请求并报 415。这里只针对真正含文件的表单改走 multipart，
// 纯字符串的 FormData 调用保持原样（那些接口是靠 JSON 体绑定的，动它们会引入回归）。
instance.interceptors.request.use(cfg => {
	const token = gettoken()
	const hasExplicitAuth = cfg.headers.has('Authorization')
	if (token) {
		cfg.headers.set('Authorization', 'Bearer ' + token)
	} else if (!hasExplicitAuth) {
		// 退出页会先清本地再带旧 token 调 LogOff，显式 Header 不能被删
		cfg.headers.delete('Authorization')
	}
	const data = cfg.data
	if (data instanceof FormData && Array.from(data.values()).some(v => v instanceof Blob)) {
		cfg.headers.setContentType('multipart/form-data')
	}
	return cfg
})

instance.interceptors.response.use(response => {
	const body = response.data || {}
	const {
		code
	} = body
	//******************jiemi开始 *************************

	if (typeof (body.data) == 'string') {
		// console.log(response.data.data)

		// 验证是否为加密字符串-排除法
		if (body.data.indexOf('Files/') > -1) {
			console.log('包含Files/ 不是加密的')
			//包含files 不是加密的
		} else {
			let _token = gettoken()
			if (_token) {
				try {
					let _keystr = _token.substring(_token.length - 16, _token.length)
					let _data = aes.Decrypt(body.data, _keystr.split('').reverse().join(''), _token.substring(0, 16))
					body.data = JSON.parse(_data)
				} catch (e) {
					// token 已轮换时仍可能收到旧密文，不能让它打断后续的失效处理
					console.warn('响应解密失败：', e)
				}
			}
		}
	}

	//******************jiemi结束 *************************

	const skipAuthHandler = (response.config && response.config.skipAuthHandler) || isAuthPage()
	if (skipAuthHandler) return response

	if (code === 3001) {
		const mainStore = useMainStore()
		const userId = mainStore.userInfo && mainStore.userInfo.id
		if (!userId) {
			goSsoLogin('expired')
			return response
		}

		const config = response.config
		if (!isRefreshing) {
			isRefreshing = true

			return refreshToken().then(res => {
				const token = res && res.token
				// RefreshTokenController 成功返回 code=2（syccess_up_token），不是 1
				if (!res || (res.code !== 1 && res.code !== 2) || !token) {
					flushRequests(new Error('登录状态已失效'))
					goSsoLogin('expired')
					return Promise.reject(new Error('登录状态已失效'))
				}

				instance.setToken(token)
				config.headers.Authorization = 'Bearer ' + token
				// 已经刷新了token，将所有队列中的请求进行重试
				flushRequests(null, token)
				return instance(config)
			}).catch(res => {
				console.error('refreshtoken error =>', res)
				flushRequests(res)
				goSsoLogin('expired')
				return Promise.reject(res)
			}).finally(() => {
				isRefreshing = false
			})
		} else {
			// 正在刷新token，先入队，刷新结果出来后再重放
			return new Promise((resolve, reject) => {
				requests.push({
					resolve,
					reject,
					config
				})
			})
		}
	} else if (code === 3002) {
		goSsoLogin('expired')
	}
	return response
}, error => {
	return Promise.reject(error)
})

export default instance